import { useI18n } from '../i18n/useI18n'
import { characterKind } from '../lib/characterKind'

/**
 * キャラアセット (2D画像 / 3Dモデル / 動画) の見た目。
 *
 * 管理画面の確認用と、客が集めたキャラの一覧で共有する。**3D は静止画にできない**
 * ので、three を積んでいる /ar/ の小さなページを iframe で埋めて回して見せる
 * (PAY 本体に 600KB の依存を足さないため)。
 */
export default function CharacterPreview({
  url,
  size = 'h-24 w-24',
  detail = false,
}: {
  url: string
  /** 枠の大きさ (Tailwind)。小さすぎると立体が染みにしか見えない */
  size?: string
  /**
   * 押して開いた詳細か。**動画は音ありで再生し、操作バーを出す。**
   *
   * 一覧のサムネイルは勝手に鳴っては困るので無音のまま。詳細は
   * **自分でタップして開いた**ものなので、音が出て自然 (PR 動画は音ありが普通)。
   * 消したい人のために操作バー (音量・一時停止) を出す。
   */
  detail?: boolean
}) {
  const { t } = useI18n()
  const kind = characterKind(url)
  const cls = `${size} rounded-lg bg-gray-50 object-contain`

  if (kind === 'model') {
    return (
      <iframe
        src={`/ar/preview.html?src=${encodeURIComponent(url)}`}
        title={t('admin.stamp.arCharacterPreview3d')}
        className={`${size} rounded-lg border border-gray-200 bg-gray-50`}
      />
    )
  }
  if (kind === 'video') {
    if (detail) {
      return (
        <video
          src={url}
          className={cls}
          controls
          loop
          autoPlay
          playsInline
        />
      )
    }
    // 一覧のサムネイルは無音。勝手に音が鳴ると、開く前から騒がしくなる
    return <video src={url} className={cls} muted loop autoPlay playsInline />
  }
  return <img src={url} alt="" className={cls} />
}
